import type { NextPage } from 'next';
import { useEffect } from 'react';

import RenderOnClientReady from '~components/RenderOnClient';
import RankingContents from '~features/home/RankingContents';
import RecentComment from '~features/home/RecentComment';
import SalaryRankingNudge from '~features/home/SalaryRankingNudge';
import SideBanner from '~features/home/SideBanner';
import TopBanner from '~features/home/TopBanner';
import * as S from '~lib/styles/pages/home';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

const Home: NextPage = () => {
  useEffect(() => {
    setGtmDataLayer('home__view');
  }, []);

  return (
    <RenderOnClientReady>
      <S.HomeGlobalStyle />
      <TopBanner />
      <S.HomeLayout>
        <S.BodyWrapper>
          <RankingContents />
          <S.SideBannerWrapper>
            <SideBanner />
          </S.SideBannerWrapper>
        </S.BodyWrapper>
        <S.RecentCommentWrapper>
          <RecentComment />
        </S.RecentCommentWrapper>
      </S.HomeLayout>
      <SalaryRankingNudge />
    </RenderOnClientReady>
  );
};

export default Home;
